import moment from "moment";

const NEW_MEMBER_ENROLL_DATE = "2026-08-01";
const NEW_MEMBER_HIDE_YEAR = 2026;
const NEW_MEMBER_HIDE_MONTH = 8;
const CPB_HIDE_FOR_ALL_YEAR = 2026;
const CPB_HIDE_FOR_ALL_MONTH = 10;
const CCB_HIDE_FOR_ALL_YEAR = 2027;
const CCB_HIDE_FOR_ALL_MONTH = 1;

function isPeriodOnOrAfter(period, year, month) {
    if (!period || !period.StartDate) return false;
    const start = moment.utc(period.StartDate);
    return start.year() > year || (start.year() === year && start.month() + 1 >= month);
}

function isEnrolledOnOrAfter(signupDate, cutoffDate) {
    if (!signupDate) return false;
    return !moment.utc(signupDate).isBefore(moment.utc(cutoffDate), "day");
}

export function getCustomerBonusVisibility(period, signupDate) {
    const hideForNewMembers = isEnrolledOnOrAfter(signupDate, NEW_MEMBER_ENROLL_DATE)
        && isPeriodOnOrAfter(period, NEW_MEMBER_HIDE_YEAR, NEW_MEMBER_HIDE_MONTH);

    return {
        showCustomerPoolBonus: !(hideForNewMembers
            || isPeriodOnOrAfter(period, CPB_HIDE_FOR_ALL_YEAR, CPB_HIDE_FOR_ALL_MONTH)),
        showCumulativeCustomerBonus: !(hideForNewMembers
            || isPeriodOnOrAfter(period, CCB_HIDE_FOR_ALL_YEAR, CCB_HIDE_FOR_ALL_MONTH)),
    };
}
